export default [
    {
        method: 'getSmsSend',
        type: 'POST',
        path: '/web/sms/send',
        mode: 'passport',
        params: ["tel", "cid", "type", "ct","captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '短信发送接口(登录态)'
    },
    {
        method: 'getSmsCheck',
        type: 'POST',
        path: '/web/sms/check',
        mode: 'passport',
        params: ["tel", "cid", "type", "code", "ct"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '短信校验接口(登录态)'
    },
    {
        method: 'changeTel',
        type: 'POST',
        path: '/web/user/handle/tel',
        mode: 'passport',
        params: ["oldCode", "tel", "cid", "code", "ct"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '手机绑定或换绑接口(登录态)'
    },
    {
        method: 'changePwd',
        type: 'POST',
        path: '/web/user/change/pwd',
        mode: 'passport',
        params: ["code", "oldPwd", "pwd", "repeatPwd", "ct"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '修改密码接口(登录态)'
    },
    {
        method: 'sendEmailCode',
        type: 'POST',
        path: '/web/captcha/auth/send',
        mode: 'passport',
        params: ["user", "type","captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '邮箱验证码发送接口(登录态)'
    },
    {
        method: 'checkEmailCode',
        type: 'POST',
        path: '/web/captcha/auth/check',
        mode: 'passport',
        params: ["captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '邮箱验证码校验接口(登录态)'
    },
    {
        method: 'changeEmail',
        type: 'POST',
        path: '/web/user/email/bind',
        mode: 'passport',
        params: ["user", "captcha"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '邮箱账号换绑接口(登录态)'
    },
    {
        method: 'changeEmailPwd',
        type: 'POST',
        path: '/web/user/pwd/update',
        mode: 'passport',
        params: ["captcha", "pwd", "rePwd", "oldPwd"],
        options: { withCredentials: true, cache: false },
        switch: false,
        // desc: '邮箱账号修改密码接口(登录态)'
    },
    {
        method: 'changeNewEmailPwd',
        type: 'POST',
        path: '/web/email/change.password',
        mode: 'passport',
        params: ["access_key", "old_pwd", "new_pwd", "re_pwd", "changeBaseUrl"],
        options: { withCredentials: true, cache: false },
        switch: true,
        // desc: 'komoe东安娜亚 邮箱账号修改密码接口(登录态)'
    }
];